import { render, staticRenderFns } from "./adminWrapper.vue?vue&type=template&id=f85972d2&"
import script from "./adminWrapper.vue?vue&type=script&lang=js&"
export * from "./adminWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports